import { PMarque, PHeadline, PText, PFlex, PFlexItem, PIcon } from '@porsche-design-system/components-react'
import React from 'react'

import IconCheck from '../../shared/assets/icon_check.svg'
import IconCross from '../../shared/assets/icon_cross.svg'
import IconLaptop from '../../shared/assets/icon_laptop.svg'
import IconMonitor from '../../shared/assets/icon_monitor.svg'
import IconSmartphone from '../../shared/assets/icon_smartphone.svg'
import IconTablet from '../../shared/assets/icon_tablet.svg'
import styles from './mobileblocker.module.css'

const MobileBlocker = () => {
  return (
    <div className={styles.mobileBlocker}>
      <section className={styles.wrapper}>
        <div className={styles.content}>
          <header className={styles.header}>
            <PMarque className={styles.brand} />
            <PHeadline variant='headline-3' align='center'>
              User Rating
            </PHeadline>
          </header>
          <main>
            <PHeadline variant='headline-1' align='center'>
              Zu geringe Bildschirmgröße
            </PHeadline>
            <PText align='center' className={styles.text}>
              Kleine Bildschirmauflösungen werden vom User Rating Portal nicht unterstützt. Bitte vergößern Sie die
              Darstellung oder wechseln Sie auf ein Gerät mit einem größeren Bildschirm.
            </PText>

            <PFlex wrap='wrap'>
              <PFlexItem className={styles.item}>
                <PIcon source={IconMonitor} size='inherit' aria-label='monitor-icon' className={styles.icon} />
                <PText align='center' size='small' color='notification-success'>
                  Display
                </PText>
                <PText align='center' className={styles.check}>
                  <PIcon source={IconCheck} aria-label='monitor-icon' />
                </PText>
              </PFlexItem>
              <PFlexItem className={styles.item}>
                <PIcon source={IconLaptop} size='inherit' aria-label='laptop-icon' className={styles.icon} />
                <PText align='center' size='small' color='notification-success'>
                  Laptop
                </PText>
                <PText align='center' className={styles.check}>
                  <PIcon source={IconCheck} aria-label='monitor-icon' />
                </PText>
              </PFlexItem>
              <PFlexItem className={styles.item}>
                <PIcon source={IconTablet} size='inherit' aria-label='laptop-icon' className={styles.icon} />
                <PText align='center' size='small' color='notification-success'>
                  Tablet
                </PText>
                <PText align='center' className={styles.check}>
                  <PIcon source={IconCheck} aria-label='monitor-icon' />
                </PText>
              </PFlexItem>
              <PFlexItem className={styles.itemMobile}>
                <PIcon source={IconSmartphone} size='inherit' aria-label='laptop-icon' className={styles.icon} />
                <PText align='center' size='small' color='notification-warning'>
                  Smartphone
                </PText>
                <PText align='center' className={styles.check}>
                  <PIcon source={IconCross} aria-label='monitor-icon' />
                </PText>
              </PFlexItem>
            </PFlex>
          </main>
        </div>
      </section>
    </div>
  )
}

export default MobileBlocker
